import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Toggle from "components/atoms/Toggle";
import FilterInfo from "components/atoms/FilterInfo";
import { LEHRERINNEN_TOGGLE, DIGITAL_TOGGLE } from "constants/filter";

const ToggleFilters = ({
  className,
  onFilterToggleChange,
  lehrerInnenTotalCount,
  lehrerInnenFilter,
  digitalTotalCount,
  digitalFilter,
  totalCount,
}) => {
  const componentBaseClass = "sal-toggle-filters";
  const componentClassName = classnames(componentBaseClass, className);

  const countMapping = {
    lehrkraefte: lehrerInnenTotalCount,
    digital: digitalTotalCount,
    total: totalCount,
  };

  const [toggleFilters, setToggleFilters] = useState([
    {
      value: "Lehrkraefte",
      name: "lehrkraefte",
      label: "lehrerInnen",
      checked: false,
      count: 0,
      infoText: "Speziell für Lehrkräfte",
      filterInputName: LEHRERINNEN_TOGGLE.FILTER_INPUT_NAME,
      filterInputValue: LEHRERINNEN_TOGGLE.VALUE,
      isVisible: true,
    },
    {
      value: "Digitale Produkte",
      name: "digital",
      label: "digital",
      checked: false,
      count: 0,
      infoText: "Digitale Produkte",
      filterInputName: DIGITAL_TOGGLE.FILTER_INPUT_NAME,
      filterInputValue: DIGITAL_TOGGLE.VALUE,
      isVisible: true,
    },
  ]);

  const updateFilterCheckedStatus = () => {
    setToggleFilters((prevFilters) =>
      prevFilters.map((filter) => {
        if (filter.name === LEHRERINNEN_TOGGLE.NAME) {
          return { ...filter, checked: lehrerInnenFilter };
        } else if (filter.name === DIGITAL_TOGGLE.NAME) {
          return { ...filter, checked: digitalFilter };
        }
        return filter;
      }),
    );
  };

  const updateFilterVisibility = () => {
    setToggleFilters((prevFilters) =>
      prevFilters.map((filter) => {
        let isVisible = false;
        if (filter.name === LEHRERINNEN_TOGGLE.NAME) {
          isVisible =
            (lehrerInnenTotalCount > 0 &&
              totalCount != lehrerInnenTotalCount) ||
            filter.checked;
        } else if (filter.name === DIGITAL_TOGGLE.NAME) {
          isVisible =
            (digitalTotalCount > 0 && totalCount != digitalTotalCount) ||
            filter.checked;
        }

        return { ...filter, isVisible };
      }),
    );
  };

  useEffect(() => {
    updateFilterCheckedStatus();
    updateFilterVisibility();
  }, [
    lehrerInnenFilter,
    digitalFilter,
    lehrerInnenTotalCount,
    digitalTotalCount,
    totalCount,
  ]);

  const onChange = (item) => (e) => {
    const checked = e.target.checked;
    if (item.checked === false) {
      onFilterToggleChange(item.filterInputName, [item.filterInputValue]);
    } else {
      onFilterToggleChange(item.filterInputName, []);
    }
    setToggleFilters((prevFilters) =>
      prevFilters.map((filter) =>
        filter.name === item.name ? { ...filter, checked: checked } : filter,
      ),
    );
  };
  return (
    <div className={componentClassName}>
      {toggleFilters.map((toggleFilter) => (
        <div
          className={`${componentBaseClass}__filter-item ${toggleFilter.isVisible ? "" : "hidden"}`}
          key={toggleFilter.value}
        >
          <Toggle
            checked={toggleFilter.checked}
            onChange={onChange(toggleFilter)}
            name={toggleFilter.name}
            disabled={!toggleFilter.isVisible}
          />
          <FilterInfo
            toggleStatus={toggleFilter.checked}
            count={countMapping[toggleFilter.name]}
            name={toggleFilter.name}
            filterInfoText={toggleFilter.infoText}
          />
        </div>
      ))}
    </div>
  );
};

ToggleFilters.propTypes = {
  className: PropTypes.string,
  onFilterToggleChange: PropTypes.func.isRequired,
  lehrerInnenTotalCount: PropTypes.number,
  digitalTotalCount: PropTypes.number,
  lehrerInnenFilter: PropTypes.bool,
  digitalFilter: PropTypes.bool,
  totalCount: PropTypes.number,
};

export default ToggleFilters;
